module.exports = __webpack_public_path__ + "img/LogoLoading_circle02.1b65931d.png";